import { FC, ReactElement } from 'react'
import {
  ThemeProvider as MThemeProvider,
  CssBaseline,
  responsiveFontSizes,
  createTheme,
  SimplePaletteColorOptions,
} from '@mui/material'

declare module '@mui/material' {
  interface PaletteColorOptions {
    faded?: string
    dark?: string
    light?: string
    main?: string
  }
  interface PaletteColor {
    faded?: string
    main: string
  }
  interface PaletteOptions {
    muted?: SimplePaletteColorOptions
    ltblue?: SimplePaletteColorOptions
    // mutedLight?: SimplePaletteColorOptions
    // successLight?: SimplePaletteColorOptions
    // errorLight?: SimplePaletteColorOptions
    // warningLight?: SimplePaletteColorOptions
  }
  interface Palette {
    muted: PaletteColorOptions
    ltblue: PaletteColorOptions
    // mutedLight: PaletteColorOptions
    // successLight: PaletteColorOptions
    // errorLight: PaletteColorOptions
    // warningLight: PaletteColorOptions
  }
}

export const theme = responsiveFontSizes(
  createTheme({
    palette: {
      // blue pulled from HIV logo
      primary: {
        main: '#1F2F4A',
      },
      // red pulled from HIV logo
      secondary: {
        main: '#CE372A',
      },
      ltblue: {
        main: '#DBFBFF',
      },
      success: {
        dark: '#388e3c',
        main: '#4caf50',
        faded: '#e5ffe6',
      },
      error: {
        dark: '#d32f2f',
        main: '#f44336',
        faded: '#ffe2e0',
      },
      warning: {
        dark: '#f57c00',
        main: '#ff9800',
        light: '#ffb74d',
        faded: '#fff3e5',
      },
      muted: {
        dark: '#CCCCCC',
        main: '#dedede',
        light: '#efefef',
      },
    },
    typography: {
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        '"Open Sans"',
        '"Lucida Grande"',
        'Verdana',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
    components: {
      MuiGrid: {
        styleOverrides: {
          root: {
            padding: 0,
            paddingLeft: 0,
          },
          container: {
            padding: 0,
            paddingLeft: 0,
            
          },
          item: {
            padding: 0,
            paddingLeft: 0,
          },
          
        }
      }
    }
  })
)

export interface ThemeProviderProps {
  children: ReactElement | ReactElement[]
}
export const ThemeProvider: FC<ThemeProviderProps> = ({ children }) => {
  return (
    <CssBaseline>
      <MThemeProvider theme={theme}>{children}</MThemeProvider>
    </CssBaseline>
  )
}

export default ThemeProvider
